export enum UserInfoRole {
  ADMIN = 'admin',
  INTERNAL = 'internal',
}
